import { render, staticRenderFns } from "./TaskShow.vue?vue&type=template&id=44944659&"
import script from "./TaskShow.vue?vue&type=script&lang=js&"
export * from "./TaskShow.vue?vue&type=script&lang=js&"
import style0 from "./TaskShow.vue?vue&type=style&index=0&id=44944659&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports